 <template>
	<div class="window">
        <div class="header"><span v-html="translation.wprowadz_kod"></span>
            <a class="description" @click="openDescription"><information-circle-icon class="icon"/></a>
            <a class="settings" @click="openSettings"><cog-6-tooth-icon class="icon"/></a>
        </div>
        <div class="description-box">
            <h2>{{ translation.wprowadz_kod_gry }}</h2>
            <div class="help-box mt2x">
                <div class="help-text" v-html="translation.help8">
                </div>
            </div>
            <div>
                <input type="text" name="kod" value="" v-model="code" maxlength="8" class="code-input"
                     @change="validateCode" @keyup="validateCode" autocomplete="off" />
            </div>
        
            <div class="alert-box" :class="(errorMessage!='')?'visible':''">
                <div class="alert-text">
                    <div class="line2">{{ errorMessage }}</div>
                </div>
            </div>
        </div>
        <a class="back-screen" @click="doNowejGry"><chevron-left-icon class="icon" /><span v-html="translation.back"></span></a>
    </div>
</template>

<script>
import de from '../locale/de.js';
import en from '../locale/en.js';
import es from '../locale/es.js';
import fr from '../locale/fr.js';
import it from '../locale/it.js';
import pl from '../locale/pl.js';
import pt from '../locale/pt.js';
import { Cog6ToothIcon, InformationCircleIcon, ChevronLeftIcon } from '@heroicons/vue/24/solid';
import axios from 'axios'

export default {
    name: 'WpiszKod',
    props: {
        language: String
    },
    components: { 
        Cog6ToothIcon,
        InformationCircleIcon,
        ChevronLeftIcon
    },
    data() {
        return {
            lang: localStorage.getItem('language'),
            translation: pl,
            code: '',
            timer: false,
            errorMessage: '',
            theme: localStorage.getItem('theme'),
        }
    },
    beforeMount() {
        switch(localStorage.getItem('language'))
        {
            case 'de':
                this.translation = de;
                break;
            case 'en':
                this.translation = en;
                break;
            case 'es':
                this.translation = es;
                break;
            case 'fr':
                this.translation = fr;
                break;
            case 'it':
                this.translation = it;
                break;
            case 'pt':
                this.translation = pt;
                break;
            default:
                this.translation = pl;
                break;
        }
    },
    methods: {
        doNowejGry() {
            clearTimeout(this.timer)
            this.$emit('go-nowa-gra');
        },
        openSettings() {
            this.$emit('open-settings');
        },
        openDescription() {
            this.$emit('open-description');
        },
        validateCode() {
            this.errorMessage = ''
            clearTimeout(this.timer)

            const codeRegex = /^\d{8}$/
            if (!codeRegex.test(this.code)) {
                this.timer = setTimeout(function() {
                    this.errorMessage = this.translation.nieprawidlowy_kod_gry
                }.bind(this), 1000);
            } else {
                this.errorMessage = ''
                this.tryJoinGame()
            }
        },
        updateCharCount() {
            this.charCount = this.message.length
        },
        async tryJoinGame (proba=1) {
            try {
                this.$emit('show-spinner', true);
                var data = new FormData();
                data.append('method', 'apply-to-game');
                data.append('device-id', localStorage.getItem('device-id'));
                data.append('lang', this.lang);
                data.append('blik', this.code);
                data.append('unlocked', localStorage.getItem('alreadypaid'));

                await axios.post('https://gra.wrealizacji.pl/api3.php', data)
                .then((res) => {
                    if (res.data.type == 'error' && res.data.message!='') {
                        this.$emit('show-spinner', false);
                        this.errorMessage = this.translation.nieprawidlowy_kod_gry;
                    }
                    else if (res.data.type != 'success' && proba<10) {
                        proba++;
                        setTimeout(function () { 
                            this.tryJoinGame(proba) 
                        }.bind(this), 1000)
                    } else if (res.data.type != 'success' && proba>=10) {
                        proba++;
                        this.errorMessage = this.translation.blad_polaczenia;
                        this.$emit('show-spinner', false);
                    } else {
                        this.errorMessage = '';
                        
                        /*
                        zapisuje dane do polaczenia
                        */
                        sessionStorage.removeItem('blik');
                        localStorage.setItem('game-settings-hash', res.data.game.hash);
                        localStorage.setItem('game-hash-confirmed', res.data.game.hash);
                        localStorage.setItem('game-settings-imie1', res.data.game.name1);
                        localStorage.setItem('game-settings-imie2', res.data.game.name2);
                        localStorage.setItem('game-settings-unlocked', localStorage.getItem('paid-game'));
                        localStorage.setItem('game-offset', "0");
                        
                        /*
                        zapisuje konfiguracje poziomow
                        */
                        let obj = {}
                        for(let level=1; level<=res.data.levels.length; level++) {
                            for(let sublevel = 1; sublevel<=3; sublevel++) {
                                obj = {
                                    zgodnosc: 0,
                                    status: 0,
                                    unlocked: (level<=3 && sublevel==1)?'yes':localStorage.getItem('paid-game'),
                                    name: res.data.levels[level-1].name,
                                    position:level,
                                    wynik: -1,
                                    ID: res.data.levels[level-1].ID
                                }
                                localStorage.setItem('levels-'+level+'-'+sublevel, JSON.stringify(obj));
                            }
                        }

                        /*
                        przekierowuje na pole z kodem qr i blikiem do przepisania
                        */
                        this.$emit('show-spinner', false);
                        this.$emit('go-to-poziomy');
                    }
                }).catch((error) => {
                    console.log(error);
                    this.errorMessage = this.translation.blad_polaczenia;
                    this.spinner = false;
                });
            } catch (err) {
                proba++;
                if (proba < 10) {
                    setTimeout(function () { 
                        this.tryJoinGame(proba) 
                    }.bind(this), 1000) 
                } else {
                    this.errorMessage = this.transition.blad_polaczenia;
                    this.spinner = false;
                }
            }
        },








    },
    watch: {
        language(l) {
            this.lang = l;
            switch(localStorage.getItem('language'))
            {
                case 'de':
                    this.translation = de;
                    break;
                case 'en':
                    this.translation = en;
                    break;
                case 'es':
                    this.translation = es;
                    break;
                case 'fr':
                    this.translation = fr;
                    break;
                case 'it':
                    this.translation = it;
                    break;
                case 'pt':
                    this.translation = pt;
                    break;
                default:
                    this.translation = pl;
                    break;
            }

        }
    },
}
</script>

<style scoped>
a.back-screen {
    position:fixed;
    left:10px;
    bottom:10px;
    color: var(--bs-button-text);
}
a.back-screen svg {
    width: 15px;
    margin-top:5px;
    position:absolute;
}
a.back-screen span {
    padding-left: 20px;
}
 .code-input {
    width: calc(100% - 6px); 
    margin-top: 2em;
          height: 50px;
            border: 1px solid #e1e5e9;
            border-radius: 6px;
            font-size: 20px;
            font-weight: bold;
            text-align: center;
            color: var(--bs-button-text);
            outline: none;
            transition: all 0.3s ease;
            background: transparent;
            letter-spacing: 10px;
        }

.header {
    font-weight:bold;
    border-bottom: 1px solid var(--bs-gradient-to);
    -webkit-box-shadow: 0px 0px 10px 0px rgba(243, 40, 120, 1);
    -moz-box-shadow: 0px 0px 10px 0px rgba(243, 40, 120, 1);
    box-shadow: 0px 0px 10px 0px rgba(243, 40, 120, 1);
    color: white;
    height:50px;
    display: block;
    line-height: 50px;
    position:fixed;
    top:0;
    left:0;
    right:0;
    text-align:left;
    padding: 0 20px;
    background-color: var(--bs-gradient-to);
}

a.settings svg {
    width: 25px;
    position:absolute;
    right: 20px;
    top:12px;
}

a.description svg {
    width: 25px;
    position:absolute;
    right: 60px;
    top:12px;
}
.description-box {
    padding: 0 20px;
    background-color:var(--bs-button-background);
    color: var(--bs-button-text);
    position: fixed;
    top: 50px;
    left: 0;
    right: 0;
    bottom: 60px;
    overflow: auto;
}

.btn.btn-all {
    font-size: 1em;
    height: 3em;
    width: 80%;
    border-radius: 10px;
    margin: 5px auto;
    font-weight:bold;
    position: relative;
}
button.btn {
    font-size: 1em;
    font-family: 'Jost', sans-serif;
}
.btn-green {
    background-color: var(--bs-gradient-to);
    color: var(--bs-pink-button-color);
    position: relative;
    border-color:white;
    border: 0 none;
}
.btn-green::after {
    content: '';
    position: absolute;
    right: 20px;
    top: 50%;
    width: 12px;
    height: 12px;
    border-right: 2px solid var(--bs-pink-button-color);
    border-bottom: 2px solid var(--bs-pink-button-color);
    transform: translateY(-50%) rotate(-45deg);
    animation: chevronPulse 1s infinite;
    transition: transform 0.3s ease;
}

@keyframes chevronPulse {
    0%, 100% {
        transform: translateY(-50%) rotate(-45deg) translateX(0);
        opacity: 1;
    }
    50% {
        transform: translateY(-3px) rotate(-45deg) translateX(5px);
        opacity: 0.5;
    }
}

.podpowiedz {
    background-color: #e0e0e0;
    padding: 15px;
    border: 1px solid #999;
    border-radius: 15px;
    margin-bottom: 2em;
    font-size: 1.2em;
    text-align: center;
        margin-left: 30px;
    margin-right: 30px;
}
.dark .podpowiedz {
    background-color: #333;
    /* padding: 15px; */
    border: 1px solid #999;
    /* border-radius: 15px; */
    /* margin-bottom: 2em; */
    /* font-size: 1.2em; */
    /* text-align: center; */
    color: white;
}
.mt2x {
    margin-top: 2em;
}


body.dark div.grey-box {
    /* margin: 1em 0.5em; */
    background-color: #444;
    /* padding: 1em; */
    /* border-radius: 10px; */
}

div.grey-box {
    margin: 1em 0.5em;
    background-color: #eaeaea;
    padding: 1em;
    border-radius: 10px;
    overflow: auto;
}

.input-group {
    display: block;
    margin-bottom: 1em;
}
.input-group label {
    display: block;
}
body.dark .input-group input[type='text'] {
    border-top: 0 none;
    border-left: 0 none;
    border-right: 0 none;
    border-bottom: 1px solid #4e4b66;
    background-color: rgb(59, 59, 59);
    /* padding: 10px; */
    /* font-size: 20px; */
    color: white;
    /* width: calc(100% - 25px); */
    /* display: block; */
}

.input-group input[type='text'] {
    border-top: 1px solid #d0d0d0;
    border-left: 1px solid #d0d0d0;
    border-right: 1px solid #d0d0d0;
    border-bottom: 1px solid #4e4b66;
    padding: 10px;
    background-color: white;
    font-size: 20px;
    color: black;
    width: calc(100% - 25px);
    display: block;
}

#komunikat {
    text-align: center;
    color: red;
    font-weight: 500;
}
 .alert-box {
    background: #fef9e7;
    border: 1px solid #f59e0b;
    border-radius: 8px;
    padding: 20px;
    margin-top:1em;
    box-shadow: 0 4px 12px rgba(245, 158, 11, 0.2);
    position: relative;
    overflow: hidden;
    visibility:hidden;
}
.alert-box.visible {
    visibility: visible;
}
        .alert-box::before {
            content: '⛔';
            position: absolute;
            top: -10px;
            right: -10px;
            font-size: 80px;
            opacity: 0.15;
            transform: rotate(15deg);
            animation: alertPulse 1s infinite;

        }

        .alert-text {
            position: relative;
            z-index: 1;
            color: #991b1b;
            line-height: 1.5;
            margin: 0;
        }

        .alert-text .line2 {
            font-weight:bold;
        }
</style>
